import React, { useEffect, useRef, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Col,
  Row,
  Card,
  UncontrolledPopover,
  PopoverBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  FormFeedback,
  ModalFooter,
} from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import action from "../../../assets/icons/action.svg"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { Link, useLocation, useNavigate } from "react-router-dom"
import {
  searchMaterialRequest,
  searchMaterialRequestFinance,
  updateAction,
  updateSupplierStatus,
} from "../../../services/procurement/materialrequest"
import MaterialFilter from "./filter"
import moment from "moment"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import closeIcon from "../../../assets/icons/close.svg"
import LoadingButton from "../../../components/Common/LoadingButton"
import { UFEditor } from "../../../components/Common/Fields/Input"
import NumberFormat from "../../../utils/numberFormat"

const MaterialRequest = ({ fromDashboard, projectId }) => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Material Requests${companyname ? ` | ${companyname}` : "MEP -Hub"
    }`

  const crumb = localStorage.getItem("tagLine") || "";

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const schema = yup.object().shape({
    remarks: yup.string(),
  })

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  })
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
  })

  const { loggedUser } = useSelector(LoginProperties)

  const navigate = useNavigate()
  const [refresh, setRefresh] = useState(0)
  const [materialRequest, setMaterialRequest] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [mrno, setMRNo] = useState("")
  const [page, setPage] = useState("")
  const [datefrom, setDatefrom] = useState("")
  const [dateto, setDateto] = useState("")
  const [financial, setFinancial] = useState(true)

  const [modal, setModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [dataPerPage, setDataPerPage] = useState(25)
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  const toggle = () => setModal(!modal)

  const desimalrange = localStorage.getItem("desimalrange") || 2

  // const handleActivate = item => {
  //   const updateStatus = async item => {
  //     const response = await updateSupplierStatus(item)
  //     toastSuccess(response?.message)
  //     setRefresh(refresh + 1)
  //   }
  //   updateStatus(item)
  // }

  const handleModal = data => {
    setModal(!modal)

    reset({ ...data })
  }

  const handleRegistration = async data => {
    setIsLoading(true)
    try {
      const response = await updateAction(data)
      toastSuccess(response?.message)
      setRefresh(refresh + 1)
      setModal(false)
    } catch (err) {
      toastError(err?.message || "Something went wrong")
    }
    setIsLoading(false)
  }

  const handleAction = async data => {
    const response = await updateAction(data)
    toastSuccess(response?.message)
    setRefresh(refresh + 1)
  }

  const columns = [
    {
      label: "MR No.",
      renderCell: item => {
        return (
          <span className="d-flex align-items-center">
            {loggedUser?.permission?.some(
              permissionItem => permissionItem?.name === "materialrequest_view"
            ) ? (
              <div
                onClick={() =>
                  navigate(`/project-materialreq/view/${item?.id}`, {state: {menuLabel: crumb}})
                }
                className="pointer fw-bold"
              >
                {item?.code}
              </div>
            ) : (
              <div>{item?.code}</div>
            )}
            {[3, 4].includes(item?.status) ? (
              <>
                <span
                  className={`fs-11 ms-2 ${item?.status === 3
                      ? "status-active-cap"
                      : item?.status === 4
                        ? "status-inactive-cap"
                        : ""
                    }`}
                >
                  {item?.approved_or_rejected_by?.name}
                </span>
              </>
            ) : (
              <></>
            )}
          </span>
        )
      },
    },
    {
      label: "Project Code",
      renderCell: item => item?.project?.project_code,
    },
    {
      label: <div className="text-end pe-3">Total Material</div>,
      renderCell: item => (
        <div className="text-end pe-3">
          {NumberFormat(
            Number(item?.materials_sum_requested_quantity),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
    },
    {
      label: "Request date",
      renderCell: item => moment(item?.request_date).format("DD-MMM-YYYY"),
    },
    {
      label: "Expected Delivery Date",
      renderCell: item => moment(item?.exp_Delivery_date).format("DD-MMM-YYYY"),
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <span
            className={`font-13 ${item?.status === 1
                ? "status-draft"
                : item?.status === 2
                  ? "status-posted"
                  : item?.status === 3
                    ? "status-active"
                    : item?.status === 4 ? "status-inactive" : "status-inactive"
              }`}
          >
            {item?.status === 1
              ? "Draft"
              : item?.status === 2
                ? "Requested"
                : item?.status === 3
                  ? "Approved"
                  : item?.status === 4
                    ? "Rejected"
                    : "Closed"}
          </span>
        </div>
      ),
    },
    {
      label: "Remarks",
      renderCell: item => (item?.remarks ? item?.remarks : "-"),
    },
    {
      label: "Action",
      renderCell: item =>
        fromDashboard ? (
          item?.request_status == 0 ? (
            <>
              <div>
                <Button
                  color={"primary"}
                  className="btn btn-primary me-2"
                  onClick={() =>
                    handleAction({ materialReq: item?.id, status: 3 })
                  }
                >
                  Accept
                </Button>
                <Button
                  className="hover-button"
                  onClick={() =>
                    handleAction({ materialReq: item?.id, status: 4 })
                  }
                >
                  Reject
                </Button>
              </div>
            </>
          ) : (
            <></>
          )
        ) : (
          <>
            <div>
              <span id={`PopoverLegacy-${item?.id}`}>
                <img src={action} alt="" className="pointer" />
              </span>
            </div>
            <UncontrolledPopover
              placement="bottom"
              target={`PopoverLegacy-${item?.id}`}
              trigger="legacy"
            >
              <PopoverBody>
                {/* {item?.listing_status == 1 && (
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      navigate(`/procurement-purchase-order/add`, {
                        state: item,
                      })
                    }
                  >
                    Convert to PO
                  </div>
                )} */}
                <div
                  className="table-popup-content"
                  onClick={() =>
                    navigate(`/project-materialreq/view/${item?.id}`)
                  }
                >
                  View
                </div>
                {item?.status == 1 && (
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      navigate(`/project-materialreq/edit/${item?.id}`, {
                        state: item,
                      })
                    }
                  >
                    Edit
                  </div>
                )}
                {item?.status == 1 && (
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      handleAction({ materialReq: item?.id, status: 2 })
                    }
                  >
                    Send for Approval
                  </div>
                )}

                {item?.status == 2 ? (
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      handleModal({ materialReq: item?.id, status: 3 })
                    }
                  >
                    Approve
                  </div>
                ) : (
                  <></>
                )}

                {item?.status == 2 ? (
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      handleModal({ materialReq: item?.id, status: 4 })
                    }
                  >
                    Reject
                  </div>
                ) : (
                  <></>
                )}
                {/* {item?.status == 3 && (
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      navigate(`/central-store-rfq/add`, {
                        state: item,
                      })
                    }
                  >
                    Convert to RFQ
                  </div>
                )} */}
              </PopoverBody>
            </UncontrolledPopover>
          </>
        ),
    },
  ]

  const subOnGoingColumns = [
    {
      label: "Ref No.",
      renderCell: item => {
        return <div>{item?.code}</div>
      },
    },

    {
      label: <div className="text-end pe-5">Quantity</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(
              item?.materials_sum_quantity
                ? item?.materials_sum_quantity
                : item?.materials_sum_requested_quantity
            ),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
    },
    {
      label: "Type",
      renderCell: item => item?.type,
    },
    {
      label: "",
      renderCell: item => <></>,
    },
    {
      label: "",
      renderCell: item => <div></div>,
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }
  const handleDateChange = (fromdate, todate) => {
    setDatefrom(fromdate)
    setDateto(todate)
    setPage(1)
  }
  useEffect(() => {
    const fetchMaterialRequest = async () => {
      const response = await searchMaterialRequestFinance({
        params: `${status == "0" ||
            status == "1" ||
            status == "2" ||
            status == "3" ||
            status == "4"
            ? `&status=${status}`
            : ""
          }${`&sortOrder=asc`}${search ? `&searchText=${search}` : "&searchText"}${mrno ? `&mr_no=${mrno}` : ""
          }${datefrom ? `&requestdate_from=${datefrom}` : ""}${dateto ? `&requestdate_to=${dateto}` : ""
          }${page ? `&page=${page}` : ""}${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}${fromDashboard ? `&filter_status=0` : ""
          }${fromDashboard && projectId ? `&project_id=${projectId}` : ""
          }${`&is_project=${true}`}`,
      })
      // ${`&financial=${financial}`}

      // Merge dr and smr into one array called children for each item
      const updatedResponse = {
        ...response,
        data: {
          ...response.data,
          data: response.data?.data?.map(item => ({
            ...item,
            children: [
              ...(item.dr || []).map(d => ({ ...d, type: "Delivery Note" })),
              // ...(item.smr || []).map(s => ({ ...s, type: "SMR" })),
            ],
          })),
        },
      }
      // setMaterialRequest(updatedResponse)
      const newData = response?.data?.data || [];

      setMaterialRequest(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }
    fetchMaterialRequest()
    
  }, [refresh, status, search, mrno, page, datefrom, dateto, financial, dataPerPage])
  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }
  const handleRequestChange = id => {
    setMRNo(id)
    setPage(1)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleFinacialChange = id => {
    setFinancial(id)
    setPage(1)
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < materialRequest?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [materialRequest, page]);

  return (
    <React.Fragment>
      <div
        className={`${fromDashboard ? "pt-0 dashboard-page-content-view" : "page-content"
          }`}
      >
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            {!fromDashboard ? (
              <Breadcrumbs
                title="Project Management"
                breadcrumbObject={[
                  { title: "Project Management", link: "/project" },
                  { title: crumb || "Masterst", link: "/project" },
                  {
                    title: "Material Requests",
                    link: "",
                  },
                ]}
              />
            ) : (
              <></>
            )}
            {loggedUser?.permission?.some(
              permissionItem =>
                permissionItem?.name === "materialrequest_create"
            ) && (
                <Link
                  to="/project-materialreq/add"
                  state={{ menuLabel: crumb }}
                  className={"px-2 mb-3 me-2 btn btn-primary"}
                >
                  {"+ Material Request"}
                </Link>
              )}
          </div>
          <Card className="me-2 px-2 pb-2">
            <MaterialFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              handleRequestChange={handleRequestChange}
              handleDateChange={handleDateChange}
              handleFinacialChange={handleFinacialChange}
              sampleUrl={"download/suppliers.xlsx"}
              importUrl={"suppliers/import"}
              isImport={false}
              fromDashboard={fromDashboard}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table mr-tbl">
              <Col xs={12}>
                <div ref={tableContainerRef} style={{ height: "490px", overflowY: "auto" }}>
                  {materialRequest && (
                    <UpdateTable
                      className="mt-5"
                      nodes={materialRequest?.data?.data}
                      paginate={materialRequest?.data}
                      columns={columns}
                      subColumn={subOnGoingColumns}
                      subName={"children"}
                      expand={true}
                      subHeader={true}
                      CurrentPage={page}
                      handlePagination={handlePaginate}
                      handleSizePerPage={handleSizePerPageChange}
                      tableWidth="20% 10% 10% 10% 15% 10% 15% 10% "
                      mobileWidth="40% 40% 30% 30% 30% 30% 15% 15%"
                      isLoading={isLoadingNextPage}
                      hidePaginate={true}
                    />
                  )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
        <ModalHeader className="custom-modal-header">
          <div className="d-flex justify-content-between">
            <h5>Remarks</h5>{" "}
            <img
              src={closeIcon}
              alt=""
              onClick={toggle}
              width="10"
              role="button"
            />
          </div>
        </ModalHeader>
        <ModalBody>
          <FormProvider {...methods}>
            <Form id={`ev-form`} onSubmit={handleSubmit(handleRegistration)}>
              <Row>
                <Col sm={12}>
                  <FormGroup className="mb-4">
                    <Label>Remarks</Label>
                    <UFEditor
                      control={control}
                      placeholder="Enter Remarks"
                      rows="5"
                      name={"remarks"}
                      invalid={!!errors.remarks}
                      className={"pb-0"}
                    />
                    <FormFeedback invalid>
                      {errors.remarks?.message}
                    </FormFeedback>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </FormProvider>
        </ModalBody>
        <ModalFooter>
          <LoadingButton
            form={`ev-form`}
            color={"primary"}
            loading={isLoading}
            disabled={isLoading}
            type="submit"
          >
            Update{" "}
          </LoadingButton>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

export default MaterialRequest
